import type { DeviceSignalTarget } from '~/generated/graphql';
import { i18n } from '~/lib/i18n';
import { titleize } from '~/lib/string';
import type { NetworkDeviceSignals__DeviceSignal as DeviceSignal } from '../queries/list.generated';

// Event constants

export const COMMON_EVENTS = [{ label: 'start_time', value: 'COMMON_START_TIME' }] as const;

export const MILB_EVENTS = [
  { label: '1st_inning_start', value: 'MILB_1ST_INNING_START' },
  { label: '1st_inning_middle', value: 'MILB_1ST_INNING_MIDDLE' },
  { label: '1st_inning_end', value: 'MILB_1ST_INNING_END' },
  { label: '2nd_inning_start', value: 'MILB_2ND_INNING_START' },
  { label: '2nd_inning_middle', value: 'MILB_2ND_INNING_MIDDLE' },
  { label: '2nd_inning_end', value: 'MILB_2ND_INNING_END' },
  { label: '3rd_inning_start', value: 'MILB_3RD_INNING_START' },
  { label: '3rd_inning_middle', value: 'MILB_3RD_INNING_MIDDLE' },
  { label: '3rd_inning_end', value: 'MILB_3RD_INNING_END' },
  { label: '4th_inning_start', value: 'MILB_4TH_INNING_START' },
  { label: '4th_inning_middle', value: 'MILB_4TH_INNING_MIDDLE' },
  { label: '4th_inning_end', value: 'MILB_4TH_INNING_END' },
  { label: '5th_inning_start', value: 'MILB_5TH_INNING_START' },
  { label: '5th_inning_middle', value: 'MILB_5TH_INNING_MIDDLE' },
  { label: '5th_inning_end', value: 'MILB_5TH_INNING_END' },
  { label: '6th_inning_start', value: 'MILB_6TH_INNING_START' },
  { label: '6th_inning_middle', value: 'MILB_6TH_INNING_MIDDLE' },
  { label: '6th_inning_end', value: 'MILB_6TH_INNING_END' },
  { label: '7th_inning_start', value: 'MILB_7TH_INNING_START' },
  { label: '7th_inning_middle', value: 'MILB_7TH_INNING_MIDDLE' },
  { label: '7th_inning_end', value: 'MILB_7TH_INNING_END' },
  { label: '8th_inning_start', value: 'MILB_8TH_INNING_START' },
  { label: '8th_inning_middle', value: 'MILB_8TH_INNING_MIDDLE' },
  { label: '8th_inning_end', value: 'MILB_8TH_INNING_END' },
  { label: '9th_inning_start', value: 'MILB_9TH_INNING_START' },
  { label: '9th_inning_middle', value: 'MILB_9TH_INNING_MIDDLE' },
  { label: '9th_inning_end', value: 'MILB_9TH_INNING_END' },
  { label: 'end_of_game', value: 'MILB_END_GAME' },
  { label: 'home_team_home_run', value: 'MILB_HOME_RUN' },
  { label: 'home_team_win', value: 'MILB_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'MILB_HOME_TEAM_LOSS' },
] as const;

export const MLB_EVENTS = [
  { label: '1st_inning_start', value: 'MLB_1ST_INNING_START' },
  { label: '1st_inning_middle', value: 'MLB_1ST_INNING_MIDDLE' },
  { label: '1st_inning_end', value: 'MLB_1ST_INNING_END' },
  { label: '2nd_inning_start', value: 'MLB_2ND_INNING_START' },
  { label: '2nd_inning_middle', value: 'MLB_2ND_INNING_MIDDLE' },
  { label: '2nd_inning_end', value: 'MLB_2ND_INNING_END' },
  { label: '3rd_inning_start', value: 'MLB_3RD_INNING_START' },
  { label: '3rd_inning_middle', value: 'MLB_3RD_INNING_MIDDLE' },
  { label: '3rd_inning_end', value: 'MLB_3RD_INNING_END' },
  { label: '4th_inning_start', value: 'MLB_4TH_INNING_START' },
  { label: '4th_inning_middle', value: 'MLB_4TH_INNING_MIDDLE' },
  { label: '4th_inning_end', value: 'MLB_4TH_INNING_END' },
  { label: '5th_inning_start', value: 'MLB_5TH_INNING_START' },
  { label: '5th_inning_middle', value: 'MLB_5TH_INNING_MIDDLE' },
  { label: '5th_inning_end', value: 'MLB_5TH_INNING_END' },
  { label: '6th_inning_start', value: 'MLB_6TH_INNING_START' },
  { label: '6th_inning_middle', value: 'MLB_6TH_INNING_MIDDLE' },
  { label: '6th_inning_end', value: 'MLB_6TH_INNING_END' },
  { label: '7th_inning_start', value: 'MLB_7TH_INNING_START' },
  { label: '7th_inning_middle', value: 'MLB_7TH_INNING_MIDDLE' },
  { label: '7th_inning_end', value: 'MLB_7TH_INNING_END' },
  { label: '8th_inning_start', value: 'MLB_8TH_INNING_START' },
  { label: '8th_inning_middle', value: 'MLB_8TH_INNING_MIDDLE' },
  { label: '8th_inning_end', value: 'MLB_8TH_INNING_END' },
  { label: '9th_inning_start', value: 'MLB_9TH_INNING_START' },
  { label: '9th_inning_middle', value: 'MLB_9TH_INNING_MIDDLE' },
  { label: '9th_inning_end', value: 'MLB_9TH_INNING_END' },
  { label: 'end_of_game', value: 'MLB_END_GAME' },
  { label: 'home_team_home_run', value: 'MLB_HOME_RUN' },
  { label: 'home_team_win', value: 'MLB_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'MLB_HOME_TEAM_LOSS' },
] as const;

export const MLS_EVENTS = [
  { label: 'start_halftime', value: 'MLS_START_HALFTIME' },
  { label: 'start_2nd_half', value: 'MLS_START_2ND_HALF' },
  { label: 'end_of_game', value: 'MLS_END_GAME' },
  { label: 'home_team_goal', value: 'MLS_HOME_TEAM_GOAL' },
  { label: 'home_team_win', value: 'MLS_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'MLS_HOME_TEAM_LOSS' },
] as const;

export const NWSL_EVENTS = [
  { label: 'start_halftime', value: 'NWSL_START_HALFTIME' },
  { label: 'start_2nd_half', value: 'NWSL_START_2ND_HALF' },
  { label: 'end_of_game', value: 'NWSL_END_GAME' },
  { label: 'home_team_goal', value: 'NWSL_HOME_TEAM_GOAL' },
  { label: 'home_team_win', value: 'NWSL_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'NWSL_HOME_TEAM_LOSS' },
] as const;

export const NBA_EVENTS = [
  { label: 'end_quarter_1', value: 'NBA_END_QUARTER_1' },
  { label: 'start_quarter_2', value: 'NBA_START_QUARTER_2' },
  { label: 'start_halftime', value: 'NBA_START_HALFTIME' },
  { label: 'end_quarter_3', value: 'NBA_END_QUARTER_3' },
  { label: 'start_quarter_3', value: 'NBA_START_QUARTER_3' },
  { label: 'start_quarter_4', value: 'NBA_START_QUARTER_4' },
  { label: 'end_of_game', value: 'NBA_END_GAME' },
  { label: 'home_team_win', value: 'NBA_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'NBA_HOME_TEAM_LOSS' },
] as const;

export const NFL_EVENTS = [
  { label: 'end_quarter_1', value: 'NFL_END_QUARTER_1' },
  { label: 'start_quarter_2', value: 'NFL_START_QUARTER_2' },
  { label: 'start_halftime', value: 'NFL_START_HALFTIME' },
  { label: 'end_quarter_3', value: 'NFL_END_QUARTER_3' },
  { label: 'start_quarter_3', value: 'NFL_START_QUARTER_3' },
  { label: 'start_quarter_4', value: 'NFL_START_QUARTER_4' },
  { label: 'end_of_game', value: 'NFL_END_TIME' },
  { label: 'football_touchdown', value: 'NFL_TOUCHDOWN' },
  { label: 'football_field_goal', value: 'NFL_FIELD_GOAL' },
  { label: 'home_team_win', value: 'NFL_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'NFL_HOME_TEAM_LOSS' },
] as const;

export const NCAAF_EVENTS = [
  { label: 'end_quarter_1', value: 'NCAAF_END_QUARTER_1' },
  { label: 'start_quarter_2', value: 'NCAAF_START_QUARTER_2' },
  { label: 'start_halftime', value: 'NCAAF_START_HALFTIME' },
  { label: 'end_quarter_3', value: 'NCAAF_END_QUARTER_3' },
  { label: 'start_quarter_3', value: 'NCAAF_START_QUARTER_3' },
  { label: 'start_quarter_4', value: 'NCAAF_START_QUARTER_4' },
  { label: 'end_of_game', value: 'NCAAF_END_TIME' },
  { label: 'football_touchdown', value: 'NCAAF_TOUCHDOWN' },
  { label: 'football_field_goal', value: 'NCAAF_FIELD_GOAL' },
  { label: 'home_team_win', value: 'NCAAF_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'NCAAF_HOME_TEAM_LOSS' },
] as const;

export const NHL_EVENTS = [
  { label: 'hockey_start_1st_intermission', value: 'NHL_START_1ST_INTERMISSION' },
  { label: 'hockey_start_period_2', value: 'NHL_START_PERIOD_2' },
  { label: 'hockey_start_2nd_intermission', value: 'NHL_START_2ND_INTERMISSION' },
  { label: 'hockey_start_period_3', value: 'NHL_START_PERIOD_3' },
  { label: 'hockey_overtime', value: 'NHL_OVERTIME' },
  { label: 'end_of_game', value: 'NHL_END_GAME' },
  { label: 'home_team_goal', value: 'NHL_GOAL' },
  { label: 'home_team_win', value: 'NHL_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'NHL_HOME_TEAM_LOSS' },
] as const;

export const CHL_EVENTS = [
  { label: 'hockey_start_1st_intermission', value: 'CHL_START_1ST_INTERMISSION' },
  { label: 'hockey_start_period_2', value: 'CHL_START_PERIOD_2' },
  { label: 'hockey_start_2nd_intermission', value: 'CHL_START_2ND_INTERMISSION' },
  { label: 'hockey_start_period_3', value: 'CHL_START_PERIOD_3' },
  { label: 'hockey_overtime', value: 'CHL_OVERTIME' },
  { label: 'end_of_game', value: 'CHL_END_GAME' },
  { label: 'home_team_goal', value: 'CHL_GOAL' },
  { label: 'home_team_win', value: 'CHL_HOME_TEAM_WIN' },
  { label: 'home_team_loss', value: 'CHL_HOME_TEAM_LOSS' },
] as const;

export const EVENTS = [
  ...COMMON_EVENTS,
  ...MILB_EVENTS,
  ...MLB_EVENTS,
  ...MLS_EVENTS,
  ...NWSL_EVENTS,
  ...NBA_EVENTS,
  ...NFL_EVENTS,
  ...NCAAF_EVENTS,
  ...NHL_EVENTS,
  ...CHL_EVENTS,
] as const;

export const EVENT_VALUES = EVENTS.map((x) => x.value);

export type EventValue = (typeof EVENT_VALUES)[number];

export const getEventLabel = (eventValue: string, signalType: string): string => {
  const event = EVENTS.find((e) => e.value === eventValue);
  if (!event) return '';

  // Override "Start Time" to "Game Start Time" for sports signal types
  if (event.value === 'COMMON_START_TIME' && signalType !== 'COMMON') {
    return i18n.t('pages.device_signals.settings.events.game_start_time');
  }

  return i18n.t(`pages.device_signals.settings.events.${event.label}`);
};

// Action helpers

type SignalAction = DeviceSignal['action'];

const getActionTranslationKey = (typename: SignalAction['__typename']): string | undefined => {
  const keys = {
    SignalActionArbitrary: undefined,
    SignalActionPlayOverlay: i18n.t('pages.device_signals.settings.actions.play_overlay'),
    SignalActionPlayShow: i18n.t('pages.device_signals.settings.actions.play_show'),
    SignalActionReboot: i18n.t('pages.device_signals.settings.actions.reboot'),
    SignalActionStopOverlay: i18n.t('pages.device_signals.settings.actions.stop_overlay'),
    SignalActionTriggerView: i18n.t('pages.device_signals.settings.actions.trigger_view'),
    SignalActionTuneChannel: i18n.t('pages.device_signals.settings.actions.tune_channel'),
  } satisfies Record<SignalAction['__typename'], string | undefined>;
  return keys[typename];
};

const getArbitraryActionTranslationKey = (arbitrary: string): string | undefined => {
  const keys: Record<string, string | undefined> = {
    tv_off: i18n.t('pages.device_signals.settings.actions.tv_off'),
    tv_on: i18n.t('pages.device_signals.settings.actions.tv_on'),
  };
  return keys[arbitrary];
};

export const humanizeAction = (action: SignalAction): string => {
  if (action.__typename === 'SignalActionArbitrary') {
    const key = getArbitraryActionTranslationKey(action.arbitrary);
    return key || titleize(action.arbitrary);
  }
  const key = getActionTranslationKey(action.__typename);
  return key || action.__typename;
};

export const actionTargetName = (action: SignalAction): string => {
  if (action.__typename === 'SignalActionPlayOverlay') return action.overlay?.name ?? '';
  if (action.__typename === 'SignalActionPlayShow') return action.show?.name ?? '';
  if (action.__typename === 'SignalActionTriggerView') return action.view?.name ?? '';
  if (action.__typename === 'SignalActionTuneChannel') return action.channel?.name ?? '';
  return '';
};

// Event helpers

export const isEventName = (name: unknown): name is EventValue =>
  EVENT_VALUES.some((x) => x === name);

const eventName = (event: object | null | undefined) =>
  event && 'name' in event && typeof event.name === 'string' && isEventName(event.name)
    ? event.name
    : null;

export const formattedEventName = (event: object | null | undefined, signalType: string) => {
  const name = eventName(event);
  if (!name) return null;

  return getEventLabel(name, signalType);
};

const eventOffset = (event: object | null | undefined) =>
  event && 'offset' in event && typeof event.offset === 'number' ? event.offset / 60_000 : null;

export const toEventJson = (event: object | null | undefined) => {
  const name = eventName(event);
  const offset = eventOffset(event);

  return name != null ? (offset != null ? { name, offset } : { name }) : {};
};

// Target helpers

export const toTargetJson = (
  signal: DeviceSignal | null | undefined,
): DeviceSignalTarget | null => {
  if (signal == null) return null;

  return signal.allDevices
    ? { allDevices: true }
    : signal.deviceGroup
    ? { deviceGroupId: signal.deviceGroup.id }
    : signal.deviceDynamicCollection
    ? { deviceDynamicCollectionId: signal.deviceDynamicCollection.id }
    : null;
};

// Action helpers

export type PartialAction =
  | { command: 'arbitrary'; arbitrary: string }
  | { command: 'play_overlay'; id?: number }
  | { command: 'play_show'; id?: number }
  | { command: 'reboot' }
  | { command: 'stop_overlay' }
  | { command: 'trigger_view'; id?: number }
  | { command: 'tune_channel'; id?: number };

export const toActionJson = (action: SignalAction | null | undefined): PartialAction | null => {
  if (action == null) return null;

  return action.__typename === 'SignalActionArbitrary'
    ? { command: 'arbitrary', arbitrary: action.arbitrary }
    : action.__typename === 'SignalActionPlayOverlay'
    ? { command: 'play_overlay', id: action.overlay?.id }
    : action.__typename === 'SignalActionPlayShow'
    ? { command: 'play_show', id: action.show?.id }
    : action.__typename === 'SignalActionReboot'
    ? { command: 'reboot' }
    : action.__typename === 'SignalActionStopOverlay'
    ? { command: 'stop_overlay' }
    : action.__typename === 'SignalActionTriggerView'
    ? { command: 'trigger_view', id: action.view?.id }
    : // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    action.__typename === 'SignalActionTuneChannel'
    ? { command: 'tune_channel', id: action.channel?.id }
    : null;
};
